import {SearchResults} from './searchResults';
import {JobOpeningSearchResult} from '../model/jobOpeningSearchResult';

export const JobOpeningSearchResults = SearchResults.extend({
    _name: 'JobOpenings',
    model: JobOpeningSearchResult,
    url: '/jobs/jobs-search.json',
});
